import {
	fetchPartnerWorkerSenderRun,
	fetchPartnerWorkerSenderRunEvents,
} from '@/api/partner-workers';
import { ROUTES } from '@/app/routes';
import EntityHeroCard from '@/components/navigation/entity-hero-card';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { useSenderRunDetail } from '@/hooks/use-sender-run-detail';
import { PageScroll } from '@/layouts/page-layout';
import LandingsErrorState from '@/pages/landings/components/landings-error-state';
import SenderRunDetailView from '@/pages/sender/sender-run-detail-view';
import { ArrowLeftIcon } from 'lucide-react';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';

export default function PartnerWorkerSenderRunDetailPage() {
	const params = useParams();
	const navigate = useNavigate();
	const workerProfileId = Number(params.profileId);
	const runId = params.runId ?? '';

	const loadRun = useCallback(async () => {
		if (!Number.isFinite(workerProfileId) || !runId) throw new Error('missing params');
		return fetchPartnerWorkerSenderRun(workerProfileId, runId);
	}, [workerProfileId, runId]);

	const loadEvents = useCallback(async () => {
		if (!Number.isFinite(workerProfileId) || !runId) throw new Error('missing params');
		const data = await fetchPartnerWorkerSenderRunEvents(workerProfileId, runId, { limit: 100 });
		return data.items;
	}, [workerProfileId, runId]);

	const { run, events, loading, loadData } = useSenderRunDetail({
		enabled: Number.isFinite(workerProfileId) && Boolean(runId),
		loadRun,
		loadEvents,
	});

	const handleBack = useCallback(() => {
		navigate(`${ROUTES.worker}${workerProfileId}`);
	}, [navigate, workerProfileId]);

	if (!Number.isFinite(workerProfileId) || !runId) {
		return <div className='p-4 text-muted-foreground text-sm'>Некорректные параметры</div>;
	}

	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			<EntityHeroCard
				title='Sender run'
				subtitle={run?.caption ? run.caption.slice(0, 80) : runId}
				trailing={
					<Button type='button' variant='outline' size='sm' onClick={handleBack}>
						<ArrowLeftIcon size={14} className='mr-1' />
						Назад
					</Button>
				}
			/>

			{loading ? (
				<div className='flex justify-center py-16'>
					<Spinner />
				</div>
			) : !run ? (
				<LandingsErrorState onRetry={() => void loadData(true)} />
			) : (
				<SenderRunDetailView run={run} events={events} />
			)}
		</PageScroll>
	);
}
